export const playStyle = {
  alignItems: 'center',
  justifyContent: 'center',
};

export const pauseStyle = {
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
};
